import { ImageProps } from './image-props';

export const AssigneeBlake24Image = (props: ImageProps) => {
  return (
    <img
      height={24}
      width={24}
      alt={props.alt}
      src="https://cdn.bfldr.com/K3MHR9G8/at/fsrjztkcp8h75498bkv6xv7/Aliza.svg?auto=webp&format=png&width=48&height=48"
      data-testid={props['data-testid']}
      className={props.className}
    />
  );
};
